import { Role, RoleAPI } from './role';
import { Qualification, QualificationAPI } from "./qualifications";
import { PrescriptionFormAPI } from './prescriptionForm/prescriptionForm';

export class User {
  id: number;
  prenom: string;
  nom: string;
  username: string;
  email: string;
  role: Role | undefined;
  id_medecin: number;
  rpps?: number;
  ordocli_uuid: string;
  signature: string;
  actif: boolean;
  qualification: Qualification | undefined;
  autorisations: Map<string, Array<number>> | null;

  constructor(
    id: number,
    prenom: string,
    nom: string,
    username: string,
    email: string,
    role: Role | undefined,
    id_medecin: number,
    rpps: number,
    ordocli_uuid: string,
    signature: string,
    actif: boolean,
    qualification: Qualification | undefined,
    autorisations: Map<string, Array<number>> | null,
  ) {
    this.id = id;
    this.prenom = prenom;
    this.nom = nom;
    this.username = username;
    this.email = email;
    this.role = role;
    this.id_medecin = id_medecin;
    this.rpps = rpps;
    this.ordocli_uuid = ordocli_uuid;
    this.signature = signature;
    this.actif = actif;
    this.qualification = qualification;
    this.autorisations = autorisations;
  }

  static factory(userAPI: UserAPI): User {
    return new User(
      userAPI.id,
      userAPI.first_name,
      userAPI.last_name,
      userAPI.username,
      userAPI.email,
      userAPI.role
        ? new Role(userAPI.role.id, userAPI.role.slug, userAPI.role.name)
        : undefined,
      userAPI.id_medecin,
      userAPI.rpps,
      userAPI.ordoclic_uuid,
      userAPI.signature,
      userAPI.actif,
      userAPI.qualification
        ? new Qualification(
            userAPI.qualification.id,
            userAPI.qualification.slug,
            userAPI.qualification.name,
          )
        : undefined,
      userAPI.autorisations
        ? new Map(
            Object.entries(userAPI.autorisations).map(([key, value]) => [
              key,
              value,
            ]),
          )
        : null,
    );
  }

  toAPI(): UserAPI {
    return {
      id: this.id,
      first_name: this.prenom,
      last_name: this.nom,
      username: this.username,
      email: this.email,
      role: undefined,
      id_medecin: this.id_medecin,
      rpps: this.rpps ? this.rpps : 0,
      ordoclic_uuid: this.ordocli_uuid,
      signature: this.signature,
      qualification: undefined,
      autorisations: null,
      actif: this.actif,
    };
  }
}

export type UserAPI = {
  id: number;
  first_name: string;
  username: string;
  email: string;
  role: RoleAPI | undefined;
  last_name: string;
  id_medecin: number;
  rpps: number;
  ordoclic_uuid: string;
  signature: string;
  actif: boolean;
  qualification: QualificationAPI | undefined;
  autorisations: { [key: string]: number[] } | null;
};

export class UserList {
  list: User[];
  total: number;
  currentPage?: number;
  lastPage?: number;
  perPage?: number;
  from?: number;
  to?: number;

  constructor(
    list: User[],
    total: number,
    currentPage?: number,
    lastPage?: number,
    perPage?: number,
    from?: number,
    to?: number
  ) {
    this.list = list;
    this.total = total;
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.perPage = perPage;
    this.from = from;
    this.to = to;
  }

  static factory(userListAPI: UserListAPI): UserList {
    return new UserList(
      userListAPI.data.map((user: UserAPI) => User.factory(user)),
      userListAPI.total,
      userListAPI.current_page,
      userListAPI.last_page,
      userListAPI.per_page,
      userListAPI.from,
      userListAPI.to
    );
  }
}

export type UserListAPI = {
  data: UserAPI[];
  total: number;
  current_page?: number;
  last_page?: number;
  per_page?: number;
  from?: number;
  to?: number;
};